// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { previousTuesday as fn } from "../previousTuesday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const previousTuesday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default previousTuesday;
